import ContactForm from './components/ContactForm.vue';
import InitLazyComponent from 'Modules/InitLazyComponent';
import store from 'Stores/store';

const contactForm = document.getElementById('vue-contact-form');

if (contactForm) {
  const postType = contactForm.getAttribute('data-post-type');
  const formName = contactForm.getAttribute('data-form-name');
  const alwaysShowCitySelect = !!contactForm.getAttribute(
    'data-always-show-city-select'
  );
  const createWithoutPayment = !!contactForm.getAttribute(
    'data-create-without-payment'
  );
  const emailIsOptional = !!contactForm.getAttribute(
    'data-make-email-optional'
  );
  const therapyPageCompetence = contactForm.getAttribute(
    'data-therapy-page-competence'
  );
  const tags = contactForm.getAttribute('data-tags');
  const competenceList = contactForm.getAttribute('data-competence-list');

  const initLazyComponent = new InitLazyComponent({
    selectors: contactForm,
    components: { ContactForm },
    data: { formSent: false },
    template: `<ContactForm v-model:formSent="formSent" postType="${postType}" propFormName="${formName}" :alwaysShowCitySelect="${alwaysShowCitySelect}" :createWithoutPayment="${createWithoutPayment}" :emailIsOptional="${emailIsOptional}" therapyPageCompetence="${therapyPageCompetence}" :tags='${tags}' :competenceList='${competenceList}' />`,
    store,
  });

  initLazyComponent.init();
}
